import AccrualTypeSwitcher from './AccrualTypeSwitcher';

export default AccrualTypeSwitcher;
